"use client";

import Appbar from "./components/Appbar";
import { useRouter } from "next/navigation";
import Image from "next/image";
import React, { useState, useRef, useEffect } from "react";
import Footer from "./components/Footer";
import crypto from "./../../public/app/imagecrypto.jpeg";
import terminal from "./../../public/app/terminal.png";
import dashboard from "./../../public/app/dashboard.png";
import bstartgame from "./../../public/app/bstartgame.png";
import demotrade from "./../../public/app/demotrade.png";
import autoamount from "./../../public/app/autoamount.png";
import sendchallenge from "./../../public/app/sendchallenge.png";
import challengesent from "./../../public/app/challengesent.png";
import autopairing from "./../../public/app/autopairing.png";
import tradingviewlogo from "./../../public/app/logotradingview.png";
import binance from "./../../public/app/binance.png";

export default function Home() {
  const router = useRouter();
  const cryptoRef = useRef(null);
  const targetRef = useRef(null);
  const terminalRef = useRef(null);
  const [isCryptoInView, setIsCryptoInView] = useState(false);
  const [isTerminalInView, setIsTerminalInView] = useState(false);

  // auto scroll the page
  const scrollToTarget = () => {
    targetRef.current?.scrollIntoView({ behavior: "smooth" });

    // Add a slight delay to scroll further, creating the gap
    setTimeout(() => {
      window.scrollBy(0, 5); // Adjust the 5 to the desired gap (in pixels)
    }, 500); // Delay in ms (500ms after the initial scroll)
  };

  const [pageLoaded, setPageLoaded] = useState(false);

  useEffect(() => {
    // Set pageLoaded to true when the page is loaded
    setPageLoaded(true);
  }, []);

  console.log(pageLoaded);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.target === cryptoRef.current) {
          setIsCryptoInView(entry.isIntersecting); // Update state based on visibility
        } else if (entry.target === terminalRef.current) {
          setIsTerminalInView(entry.isIntersecting);
        }
      },
      { threshold: 0.4 } // Trigger when at least 40% of the element is visible
    );

    if (cryptoRef.current) observer.observe(cryptoRef.current);
    if (terminalRef.current) observer.observe(terminalRef.current);

    return () => {
      if (cryptoRef.current) observer.unobserve(cryptoRef.current);
      if (terminalRef.current) observer.unobserve(terminalRef.current);
    };
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            observer.unobserve(entry.target); // Stop observing after animation
          }
        });
      },
      { threshold: 0.2 }
    );

    const elements = document.querySelectorAll(".scroll-fade");
    elements.forEach((element) => {
      observer.observe(element);
    });

    return () => {
      elements.forEach((element) => {
        observer.unobserve(element);
      });
    };
  }, []);

  return (
    <>
      <div className="min-h-screen w-full bg-black flex flex-col ">
        <Appbar />
        <div className="container mx-auto w-full max-w-screen-xl mt-20 flex flex-col lg:items-center px-4">
          <div className="flex lg:flex-row flex-col justify-center lg:gap-x-8">
            <span className=" mt-4  scroll-fade lg:mt-12  text-5xl sm:text-6xl font-extrabold md:text-8xl bg-gradient-to-r from-purple-700 via-blue-500 to-teal-400 inline-block text-transparent bg-clip-text leading-none">
              Trade,
            </span>
            <span className=" mt-2 scroll-fade lg:mt-12 text-5xl sm:text-6xl md:text-8xl font-extrabold">
              Compete
            </span>
          </div>
          <h1 className=" text-5xl scroll-fade sm:text-6xl md:text-8xl text-white mt-2 font-extrabold">
            &{" "}
            <span className="bg-gradient-to-r from-purple-700 via-blue-500 to-teal-400 inline-block text-transparent bg-clip-text leading-none">
              Win
            </span>{" "}
            Big
          </h1>
          <h1 className="text-base sm:text-base lg:text-3xl text-left mt-4 scroll-fade  lg:mt-8 text-white opacity-100  ">
            Your Crypto Journey Starts Now!
          </h1>
          <h1 className="text-base sm:text-base lg:text-3xl text-left mt-4 scroll-fade lg:mt-4 text-white opacity-100  leading-normal">
            Demo Trading platform to compete with traders like you
          </h1>
          <div className="mt-8 flex  flex-col items-center sm:flex-row">
            <button
              onClick={() => {
                router.push("/signin");
              }}
              className="bg-indigo-700 hover:bg-indigo-600 h-14 w-60 sm:w-56
       md:w-52  transition duration-300 ease-in-out
        transform lg:hover:scale-105 rounded-lg font-semibold
         text-white px-4 py-2 mt-5 relative mx-8 text-base
          lg:text-xl"
            >
              Start Trading
            </button>
            <div className="relative flex justify-center items-center">
              {/* {pageLoaded && (
                <div className="absolute left-64 flex items-center space-x-3 mt-6">
                  <span className=" text-3xl text-indigo-400 mb-4">
                    &#8592;
                  </span>
                  <p className=" font-mono text-lg w-28 font-bold animate-bounce bg-gradient-to-r from-indigo-500 to-indigo-300 inline-block text-transparent bg-clip-text">
                    Click to know more
                  </p>
                </div>
              )} */}
              <button
                onClick={scrollToTarget}
                className="w-60 sm:w-56 md:w-52 h-14 transition duration-300 ease-in-out transform lg:hover:scale-105 rounded-lg font-semibold text-white px-4 py-2 border-opacity-50 mt-4 lg:mt-5 relative mx-8 text-base lg:text-xl bg-transparent border-2 border-white hover:bg-zinc-950 box-border"
              >
                Explore
                <div className="absolute top-0 left-0 rounded-lg -z-10 animate-pulse bg-zinc-500 w-full h-full opacity-90 scale-[1.0]"></div>
              </button>
            </div>
          </div>
        </div>

        {/* Description */}
        <div className="w-full max-w-full text-center mt-12 lg:mt-40 px-4">
          <div className="flex flex-col lg:flex-row gap-8 justify-center items-center">
            {/* Crypto Image Section */}
            <div className="w-full lg:w-[40%]" ref={cryptoRef}>
              <Image
                src={crypto}
                alt="crypto-image"
                className={`w-[100%] max-w-full object-contain rounded-lg shadow-lg ${
                  isCryptoInView ? "grow" : ""
                }`}
              />
            </div>

            {/* Text Section */}
            <div className="w-full lg:w-[50%] text-center lg:text-left lg:ml-8">
              <h1 className="text-white text-3xl sm:text-3xl md:text-5xl font-semibold lg:font-bold leading-tight mb-4 lg:mb-8 scroll-fade">
                India&apos;s First{" "}
                <span className=" bg-gradient-to-r from-purple-700 via-blue-500 to-teal-400 inline-block text-transparent bg-clip-text leading-none mr-2  ">
                  Gamified
                </span>
                Crypto Trading Platform
              </h1>
              <p className="text-white font-normal sm:text-lg lg:text-2xl text-lg leading-relaxed lg:mb-8 px-4 lg:px-0 scroll-fade">
                Transforms the traditional trading experience into a competitive
                game, making the world of finance accessible and exciting for
                all participants.
              </p>
            </div>
          </div>

          {/* How to Start the Game */}
          <div
            className="flex flex-col items-center text-center mt-12 lg:mt-20 px-4 "
            ref={targetRef}
          >
            <h1 className="text-white text-3xl sm:text-3xl md:text-7xl font-semibold lg:font-bold mb-4 font-inter scroll-fade">
              How it{" "}
              <span className="bg-gradient-to-r from-purple-700 via-blue-500 to-teal-400 inline-block text-transparent bg-clip-text leading-none font-extra ">
                Works
              </span>
            </h1>
            <p className="text-white font-normal w-[100%] lg:w-[60vw] sm:text-base lg:text-2xl text-lg leading-relaxed mb-8 px-4 lg:px-0">
              Ready to challenge other traders? Follow this step by step guide
              to know the rules .
            </p>
            <div className="flex flex-col items-center gap-8 w-full">
              {/* demotrade image */}
              {/* <div className="w-full h-full flex  flex-col items-center">
                <div className="w-screen lg:w-[52%] lg:h-[380px] flex justify-center border-2 border-slate-800 hover:border-slate-500 rounded-xl hover:scale-[1.01] transition-transform duration-300 overflow-hidden">
                  <Image
                    src={demotrade}
                    alt="demotrade"
                    className="w-[100%] max-w-full object-contain rounded-lg shadow-lg"
                  />
                </div>
                <div className="text-xl p-2 text-indigo-200 text-center">
                  First Take a demo Trade with us, so that we find similar
                  traders to compete . Click On the{" "}
                  <span className="text-indigo-500 font-bold">Start</span>{" "}
                  Button.
                  <br />
                  <div>
                    (You can Always Take{" "}
                    <span className="text-indigo-500 font-bold">Free</span> Demo
                    Trade )
                  </div>
                </div>
              </div> */}
              {/* <span className="text-6xl -mb-3 -mt-8 text-indigo-400">
                &#8595;
              </span> */}
              {/* dashboard image */}
              <div className="w-full flex  flex-col items-center">
                <div className="w-[98%] h-[160px] lg:w-[52%] lg:h-[380px] flex justify-center border-2 border-slate-800 hover:border-slate-500 rounded-xl hover:scale-[1.01] transition-transform duration-300 overflow-hidden">
                  <Image
                    src={dashboard}
                    alt="dashboard"
                    className="w-[100%] max-w-full object-fill lg:object-contain rounded-lg shadow-lg"
                  />
                </div>
                <p className="lg:text-xl text-lg p-2 text-white text-center">
                  Select a category
                </p>
              </div>

              <span className="text-4xl lg:text-6xl -mb-3 -mt-8 text-indigo-400">
                &#8595;
              </span>

              {/* bstartgame  */}
              <div className="w-full lg:h-[500px] flex  flex-col items-center">
                <div className="w-[98%] lg:w-[52%] lg:h-[380px] flex justify-center border-2 border-slate-800 hover:border-slate-500 rounded-xl hover:scale-[1.01] transition-transform duration-300 overflow-hidden">
                  <Image
                    src={bstartgame}
                    alt="start game"
                    className="w-[100%] max-w-full object-contain rounded-lg shadow-lg"
                  />
                </div>
                <p className="text-lg lg:text-xl p-2 text-white text-center">
                  Choose Automatic or Challenge. Window will{" "}
                  <span className="text-indigo-500">open</span> for 2 hours.
                </p>
              </div>
              <span className="text-4xl lg:hidden -mb-4 -mt-3 text-indigo-400">
                &#8595;
              </span>
              <div className="lg:flex justify-center gap-x-32 hidden">
                <p className="text-8xl lg:-mb-3 lg:-mt-28 text-indigo-400">
                  &#8601;
                  <span className="text-2xl lg:mr-10">Automatic</span>
                </p>
                <p className="text-8xl lg:-mb-3 lg:ml-10 lg:-mt-28 text-indigo-400">
                  &#8600;
                  <span className="text-2xl lg:-mr-10 ml-2 lg:ml-10">
                    Challenge
                  </span>
                </p>
              </div>
              <h1 className="text-3xl lg:hidden font-black">For Automatic </h1>
              <div className="flex-col lg:flex lg:flex-row lg:justify-center">
                {/* autoamount selection */}
                <div className="flex flex-col items-center">
                  <div className="w-[98%]  lg:w-[58%] lg:h-[430px] flex justify-center border-2 border-slate-800 hover:border-slate-500 rounded-xl hover:scale-[1.01] transition-transform duration-300 overflow-hidden">
                    <Image
                      src={autoamount}
                      alt="autoamount"
                      className="object-contain lg:object-cover w-full h-full"
                    />
                  </div>
                  <p className="text-lg lg:text-xl p-2 lg:w-[80%] text-white text-center">
                  Select amount. You&apos;ll be matched with a user who selected the same amount.
                  </p>
                </div>
                {/* send challenge */}
                <div className="lg:flex flex-col items-center hidden">
                  <div className="w-[58%] h-[200px] lg:h-[430px] flex justify-center border-2 border-slate-800 hover:border-slate-500 rounded-xl hover:scale-[1.01] transition-transform duration-300 overflow-hidden">
                    <Image
                      src={sendchallenge}
                      alt="sendchallenge"
                      className="object-cover lg:object-contain w-full h-full"
                    />
                  </div>
                  <p className="text-lg lg:text-xl p-2 text-white text-center">
                  Submit the range of your bet amount. Ask amount range will vary automatically.
                  </p>
                </div>
              </div>
              <span className="text-4xl lg:hidden lg:text-6xl -mb-3 -mt-8 text-indigo-400">
                &#8595;
              </span>
              {/* Diverging Arrows */}
              <div className="lg:flex justify-center gap-x-[45vw] hidden">
                <span className="text-6xl -mb-3 -mt-8 text-indigo-400">
                  &#8595;
                </span>
                <span className="text-6xl -mb-3 -mt-8 text-indigo-400">
                  &#8595;
                </span>
              </div>

              <div className="flex justify-center">
                {/* automatic pairing page */}
                <div className="w-full flex  flex-col items-center">
                  <div className="w-[98%] h-[160px] lg:w-[90%] lg:h-[380px] flex justify-center border-2 border-slate-800 hover:border-slate-500 rounded-xl hover:scale-[1.01] transition-transform duration-300 overflow-hidden">
                    <Image
                      src={autopairing}
                      alt="autopairing"
                      className="object-cover w-full h-full"
                    />
                  </div>
                  <p className="text-lg lg:text-xl p-2 text-white text-center">
                    ML model will find the{" "}
                    <span className="text-indigo-600">closest</span> opponent
                    from the list of people who has put the same amount
                  </p>
                </div>

                {/* challenge sent */}
                <div className="w-full lg:flex flex-col items-center hidden">
                  <div className="w-screen lg:w-[90%] lg:h-[380px] flex justify-center border-2 border-slate-800 hover:border-slate-500 rounded-xl hover:scale-[1.01] transition-transform duration-300 overflow-hidden">
                    <Image
                      src={challengesent}
                      alt="challengesent"
                      className="object-cover w-full h-full"
                    />
                  </div>
                  <p className="text-lg lg:text-xl p-2 text-white text-center ">
                    Wait for the opponent to send his Bet & Ask.{" "}
                    <span className="text-indigo-600">Redirect</span> to the
                    terminal.
                  </p>
                </div>
              </div>

              {/* Coinciding Arrows */}
              <div className="hidden lg:flex justify-center gap-x-[10vw]">
                <span className="text-8xl -mb-3 -mt-8 text-indigo-400">
                  &#8600;
                </span>
                <span className="text-8xl -mb-3 -mt-8 text-indigo-400">
                  &#8601;
                </span>
              </div>
              <h1 className="text-3xl lg:hidden font-black">For Challange </h1>
              {/* send challenge */}
              <div className="flex justify-center flex-col items-center lg:hidden">
                <div className="w-[98%] lg:w-[58%] lg:h-[430px] flex justify-center border-2 border-slate-800 hover:border-slate-500 rounded-xl hover:scale-[1.01] transition-transform duration-300 overflow-hidden">
                  <Image
                    src={sendchallenge}
                    alt="sendchallenge"
                    className="object-contain w-full h-full"
                  />
                </div>
                <p className="text-lg lg:text-xl p-2 text-white text-center">
                  Select your Bet Amount & accordingly your Ask Amount will vary
                  Based on the level of opponent
                </p>
              </div>
              <span className="text-4xl lg:hidden lg:text-6xl -mb-3 -mt-8 text-indigo-400">
                &#8595;
              </span>

              {/* challenge sent */}
              <div className="w-full flex flex-col items-center lg:hidden">
                <div className="w-[98%] lg:w-[52%] lg:h-[380px] flex justify-center border-2 border-slate-800 hover:border-slate-500 rounded-xl hover:scale-[1.01] transition-transform duration-300 overflow-hidden">
                  <Image
                    src={challengesent}
                    alt="challengesent"
                    className="object-cover w-full h-full"
                  />
                </div>
                <p className="text-lg lg:text-xl text-white text-center ">
                  Wait for the opponent to send his Bet & Ask.{" "}
                  <span className="text-indigo-600">Redirect</span> to the
                  terminal.
                </p>
              </div>
              <span className="text-4xl lg:hidden lg:text-6xl -mb-3 -mt-8 text-indigo-400">
                &#8595;
              </span>
              {/* Game Terminal */}
              <div className="w-full flex  flex-col items-center">
                <div className="w-[98%] lg:w-[52%] lg:h-[380px] flex justify-center border-2 border-slate-800 hover:border-slate-500 rounded-xl hover:scale-[1.01] transition-transform duration-300 overflow-hidden">
                  <Image
                    src={terminal}
                    alt="challengesent"
                    className="object-cover w-full h-full"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Powered By Section */}
          <div className="flex justify-center mt-8 lg:mt-10 px-4">
            <div className="mt-12 px-4 w-[100vw] lg:w-[50vw]">
              <h1 className="text-white text-3xl mb-10 lg:text-6xl font-bold leading-tight">
                Powered By
              </h1>
              <div className="overflow-hidden relative">
                <div className="flex gap-x-10 animate-slide">
                  <div className="h-[60px] w-[400px] flex items-center">
                    <Image src={tradingviewlogo} alt="logo" />
                  </div>
                  <div className="h-[60px] w-[400px] flex items-center">
                    <Image
                      src={binance}
                      alt="logo"
                      className="h-[68px] w-[350px]"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* FAQ's Section */}
        <h1 className="text-4xl sm:text-3xl font-normal text-center p-2 lg:mt-8 text-white mb-4">
          FAQ&apos;s
        </h1>
        <div className="flex items-center justify-center bg-black">
          <div className="w-[100vw] lg:w-[60vw] lg:space-y-6">
            <FaqBox
              text="How safe is crypto Tradding?"
              answer="Crypto trading is a secure and thrilling way to trade, providing fast transactions, high liquidity, and 24/7 market access.It offers a dynamic and potentially rewarding experience for traders of all levels."
            />
            <FaqBox
              text="What is the lowest amount to start with? "
              answer="On our platform, we offer free demo trades and one-on-one crypto trading sessions. You can start with a minimum amount of 50 Rupees in the beginner section."
            />
            <FaqBox
              text="Who will be your opponent?"
              answer="Our algorithm will find the best matching opponent with trading expertise similar to yours."
            />
            <FaqBox
              text="How long is the trading session?"
              answer="The duration depends on the trading category you choose, ranging from 15 minutes to 2 hours."
            />
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}

const FaqBox = ({ text, answer }) => {
  const [click, setClick] = useState(false);

  const dropDownFun = () => {
    setClick(!click);
  };

  return (
    <div className="font-normal text-xs sm:text-sm mb-4 flex flex-col items-center justify-center">
      <button
        className="w-[90vw] lg:w-full flex justify-between items-center px-2 lg:px-4 py-1 lg:py-2
         border-2 border-gray-600 rounded-lg text-left bg-gray-800
          hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-500
           transition duration-300"
        onClick={dropDownFun}
      >
        <span className="text-xs lg:text-base text-white">{text}</span>
        <div
          className={`transition-transform duration-300 ${
            click ? "transform rotate-180" : ""
          }`}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="h-5 w-5 sm:h-6 sm:w-6 text-gray-400"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="m19.5 8.25-7.5 7.5-7.5-7.5"
            />
          </svg>
        </div>
      </button>
      {click && (
        <div
          className="text-gray-300 w-[90vw] lg:w-full p-2 lg:p-4 mt-2 border-2 border-t-0 border-gray-600 bg-gray-900 rounded-lg transition-all duration-300 transform"
          style={{ transform: "translateY(0)" }} // Reset translate position
        >
          {answer}
        </div>
      )}
    </div>
  );
};
